export default __webpack_public_path__ + "static/box-usage-example-dab4b23858f30f71686f59360b420b1b447aa27d8a8f27d8791fdff9992aae0a.png";